import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const virusTotal = defineConnector({
  identifier: "virusTotal",
  name: "VirusTotal",
  tagLine: "Malware and URL analysis",
  logo,
  protocol: "http",
  tags: ["featured", "security"],
  defaultUrlPattern: () => "https://www\\.virustotal\\.com/api/v3/.*",
  auth: (app) => headerAuth([{ name: "x-apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Head to the [VirusTotal API key page](https://www.virustotal.com/gui/my-apikey), and copy your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "VirusTotal API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.virustotal.com/api/v3/users/current",
  },
});
